import { Action, createReducer, on } from '@ngrx/store';
import { addTicketSuccess, fetchTicketListData, fetchTicketListFailure, fetchTicketListSuccess } from './ticket_action';
import { TicketModel } from '../../core/models/tickets.model';

export interface TicketState {
    tickets: TicketModel[];
    loading: boolean;
    error: any;
}

export const initialState: TicketState = {
    tickets: [],
    loading: false,
    error: null,
};

export const TicketReducer = createReducer(
    initialState,
    // Contact
    on(fetchTicketListData, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchTicketListSuccess, (state, { tickets }) => {
        return { ...state, tickets, loading: false };
    }),
    on(fetchTicketListFailure, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(addTicketSuccess, (state, { newData }) => {
        return { ...state, loading: false, error: null };
    }),

);

// Selector
export function reducer(state: TicketState | undefined, action: Action) {
    return TicketReducer(state, action);
}
